import type { FormConfig } from './types'
import { b2cContactForm } from './b2cContact'
import { becomePartnerForm } from './becomePartner'
import { deviceForm } from './device'
import { instituteSearchForm } from './instituteSearch'
import { plccForm } from './plcc'

export const forms: Record<string, FormConfig> = {
  b2cContact: b2cContactForm,
  becomePartner: becomePartnerForm,
  device: deviceForm,
  instituteSearch: instituteSearchForm,
  plcc: plccForm,
}

export function getFormById(id: string | null): FormConfig | undefined {
  return forms[id ?? 'b2cContact']
}
